var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_612_8811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6458 2.66669L10.4722 2.66669V3.38891H11.5555L11.5555 11.3334L1.44442 11.3334L1.44442 3.38891L2.52776 3.38891V2.66669L1.35414 2.66669C1.26973 2.6681 1.18642 2.68612 1.10897 2.71974C1.03153 2.75335 0.961461 2.80189 0.902778 2.86259C0.844094 2.92328 0.797942 2.99494 0.766958 3.07348C0.735974 3.15201 0.720765 3.23588 0.7222 3.3203L0.7222 11.402C0.720765 11.4864 0.735974 11.5702 0.766958 11.6488C0.797942 11.7273 0.844094 11.799 0.902778 11.8597C0.961461 11.9204 1.03153 11.9689 1.10897 12.0025C1.18642 12.0361 1.26973 12.0542 1.35414 12.0556L11.6458 12.0556C11.7302 12.0542 11.8135 12.0361 11.891 12.0025C11.9684 11.9689 12.0385 11.9204 12.0972 11.8597C12.1559 11.799 12.202 11.7273 12.233 11.6488C12.264 11.5702 12.2792 11.4864 12.2778 11.402L12.2778 3.3203C12.2792 3.23588 12.264 3.15201 12.233 3.07348C12.202 2.99494 12.1559 2.92328 12.0972 2.86259C12.0385 2.80189 11.9684 2.75335 11.891 2.71974C11.8135 2.68612 11.7302 2.6681 11.6458 2.66669Z",
    fill: "#673C8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.88892 5.55554H3.61114V6.27776H2.88892V5.55554Z",
    fill: "#673C8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.05554 5.55554H5.77776V6.27776H5.05554V5.55554Z",
    fill: "#673C8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22223 5.55554H7.94445V6.27776H7.22223V5.55554Z",
    fill: "#673C8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38892 5.55554H10.1111V6.27776H9.38892V5.55554Z",
    fill: "#673C8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.88892 7.36108H3.61114V8.08331H2.88892V7.36108Z",
    fill: "#673C8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.05554 7.36108H5.77776V8.08331H5.05554V7.36108Z",
    fill: "#673C8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22223 7.36108H7.94445V8.08331H7.22223V7.36108Z",
    fill: "#673C8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38892 7.36108H10.1111V8.08331H9.38892V7.36108Z",
    fill: "#673C8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.88892 9.16669H3.61114V9.88891H2.88892V9.16669Z",
    fill: "#673C8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.05554 9.16669H5.77776V9.88891H5.05554V9.16669Z",
    fill: "#673C8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22223 9.16669H7.94445V9.88891H7.22223V9.16669Z",
    fill: "#673C8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38892 9.16669H10.1111V9.88891H9.38892V9.16669Z",
    fill: "#673C8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.61111 4.11112C3.70688 4.11112 3.79873 4.07307 3.86646 4.00535C3.93418 3.93763 3.97222 3.84578 3.97222 3.75001L3.97222 1.58334C3.97222 1.48757 3.93418 1.39572 3.86646 1.328C3.79873 1.26027 3.70688 1.22223 3.61111 1.22223C3.51534 1.22223 3.42349 1.26027 3.35577 1.328C3.28805 1.39572 3.25 1.48757 3.25 1.58334L3.25 3.75001C3.25 3.84578 3.28805 3.93763 3.35577 4.00535C3.42349 4.07307 3.51534 4.11112 3.61111 4.11112Z",
    fill: "#673C8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38888 4.11112C9.48465 4.11112 9.57651 4.07307 9.64423 4.00535C9.71195 3.93763 9.74999 3.84578 9.74999 3.75001V1.58334C9.74999 1.48757 9.71195 1.39572 9.64423 1.328C9.57651 1.26027 9.48465 1.22223 9.38888 1.22223C9.29311 1.22223 9.20126 1.26027 9.13354 1.328C9.06582 1.39572 9.02777 1.48757 9.02777 1.58334V3.75001C9.02777 3.84578 9.06582 3.93763 9.13354 4.00535C9.20126 4.07307 9.29311 4.11112 9.38888 4.11112Z",
    fill: "#673C8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69446 2.66669L8.30557 2.66669V3.38891L4.69446 3.38891V2.66669Z",
    fill: "#673C8E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_612_8811"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.3772bb7b6cfe9381f420dc01acd6e55a.svg";
export { ForwardRef as ReactComponent };